import React from 'react';

import classes from '@/components/debug-bar/styles.module.scss';

export default function DebugBar() {
    return (
        <div className={`${classes.bar}`}>
            {/* eslint-disable-next-line i18next/no-literal-string */}
            <span>Dev Mode Enabled</span>
        </div>
    );
}
